var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('LoadingState'):_vm._e(),(_vm.noCanny)?_c('div',{staticClass:"nocanny"},[_vm._v(" Feedback is not available at this time ")]):_vm._e(),_c('div',{attrs:{"data-canny":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }